import { useAiPromptsSettings } from './useAiPromptsSettings';

export { useAiPromptsSettings };
